export default __webpack_public_path__ + "static/media/subm.b44f90e8.jpg";